import React, { useCallback } from 'react';
import { RouteProps, Route, Redirect } from 'react-router';
import { useAuth } from '../AuthModule';
import { Location } from 'history';
import { isObject } from 'lodash';

interface Props extends RouteProps {}

const hasPathname = (state: unknown): state is { from: Location<any> } =>
  state != null && isObject(state) && 'from' in state;

/**
 * Rende una `Route` disponibile soltanto agli utenti non autenticati.
 */
export function AnonymousRoute(props: Props) {
  const { component, ...rest } = props;
  const { logged } = useAuth();
  const Component = component as React.ComponentType<any>;

  const redirectUrl = (props.location?.pathname ?? '').includes('/admin')
    ? '/admin'
    : '/';

  return (
    <Route
      {...rest}
      render={props =>
        !logged ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={
              hasPathname(props.location.state)
                ? props.location.state.from
                : redirectUrl
            }
          />
        )
      }
    />
  );
}
